import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Less_sm = (props) => {
    const width = props.width ? props.width + 'px' : '20px';
    const height = props.height ? props.height + 'px' : '20px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 20 20"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.25 10C17.25 10.4142 16.9142 10.75 16.5 10.75L3.5 10.75C3.08579 10.75 2.75 10.4142 2.75 10C2.75 9.58579 3.08579 9.25 3.5 9.25L16.5 9.25C16.9142 9.25 17.25 9.58579 17.25 10Z"
            />
        </SvgStyled>
    );
};

export default Less_sm;
